interface ChipProps {
  variant?: 'lumen' | 'volt' | 'required' | 'success';
  children: React.ReactNode;
  className?: string;
}

const variantClasses: Record<string, string> = {
  lumen: 'bg-chip-canvas-default-idle border-chip-border-default-idle text-text-primary',
  volt: 'bg-tag-container-default-volt border-tag-container-default-volt text-tag-text-default-volt',
  required: 'bg-tag-container-default-palmetto border-tag-container-default-palmetto text-tag-text-default-palmetto',
  success: 'bg-tag-container-default-success border-tag-container-default-success text-tag-text-default-success',
};

export const Chip = ({ variant = 'lumen', children, className }: ChipProps) => (
  <span
    className={`inline-flex items-center gap-2 rounded-full border px-12 py-4 text-sm leading-none font-medium whitespace-nowrap ${variantClasses[variant]}${className ? ` ${className}` : ''}`}
  >
    {children}
  </span>
);
